import Header from 'components/header/Header';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FmlxTab } from 'fmlx-common-ui';
import './styles.css';
import { Archive } from './archive';
import { ArchivedFiles } from './unarchiving/archivedFiles';
import { useRMDispatch } from 'redux/hooks';
import { fetchArchivedTasksThunk } from 'redux/thunks/unarchiving';
import { EArchivingDashboardTab } from './constants';
import { getArchivingTabFromSearch } from './utils';

const items = [
  {
    title: 'Archiving',
    content: <Archive />,
    icon: undefined,
    disabled: false,
  },
  {
    title: 'Archived Files',
    content: <ArchivedFiles />,
    icon: undefined,
    disabled: false,
  },
];

export const ArchivingDashboard = () => {
  const { search, key: locationKey } = useLocation();
  const dispatch = useRMDispatch();
  const [selectedTab, setSelectedTab] = useState(() => getArchivingTabFromSearch(search));

  useEffect(() => {
    setSelectedTab(getArchivingTabFromSearch(search));
  }, [search, locationKey]);

  const onTabChange = (value: { index: number | string }) => {
    const parsed = Number(value.index);
    if (Number.isNaN(parsed)) {
      return;
    }
    setSelectedTab(parsed);
    if (parsed === EArchivingDashboardTab.ArchivedFiles) {
      dispatch(fetchArchivedTasksThunk());
    }
  };

  return (
    <div className="bg-[#F5F5F5] h-[100vh] overflow-hidden">
      <div className="h-[10.6vh] overflow-hidden [&_.header-title-text]:pl-0">
        <Header isNewTheme={true} title={'Archiving'} />
      </div>
      <div className="h-[calc(100%-10.6vh)] overflow-hidden archiving-tabs">
        <FmlxTab
          type={FmlxTab.Type.CONTAINED}
          items={items}
          selectedTab={selectedTab}
          variant={FmlxTab.Variant.STANDARD}
          onChange={onTabChange}
        />
      </div>
    </div>
  );
};
